/*
 * TrendingCategories — top categories by question count, shown inside the
 * homepage hero, linking into /public-tests. Data comes from the parent so
 * the homepage fetches the categories API once.
 */

import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import type { CategoryInfo } from '@/services/client/quiz';

import './index.scss';

const TrendingCategories: FC<{ categories: CategoryInfo[] }> = ({
  categories,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'home_hero' });
  const top = [...categories]
    .filter((c) => (c.question_count || 0) > 0)
    .sort((a, b) => (b.question_count || 0) - (a.question_count || 0));

  if (!top.length) return null;

  return (
    <div className="trending-categories">
      <div className="trending-categories__header">
        {t('trending_categories')}
      </div>
      <div className="trending-categories__rows">
        {top.map((cat) => (
          <Link
            key={cat.name}
            to={`/public-tests?category=${encodeURIComponent(cat.name)}`}
            className="trending-categories__row">
            <span>{cat.name}</span>
            <span className="trending-categories__count">
              {cat.question_count || 0}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TrendingCategories;
